import {
    Component,
    ElementRef,
    Inject,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { getNameDay } from 'src/app/components/application/global.function';
import { formatUiDateTime } from 'src/app/shared/date/date.utils';
import { ConfigService } from 'src/app/services/application/config.service.';
import { AlertService } from 'src/lib/ariadna/alert';
import { HistoryService } from '../../services/history.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { lastValueFrom } from 'rxjs';
import { DicomViewModalComponent } from 'src/app/components/history/dicom-view-modal/dicom-view-modal.component';
import { HttpNewService } from 'src/app/services/application/http-new.service';
import { LoadService } from 'src/app/services/application/load.service';
import {
    IHistoryEvents,
    IHistoryItemHtmlList,
} from 'src/app/interfaces/history.interfaces';
import type { TPacsViewerAction } from 'src/app/interfaces/pacs-viewer.types';

@Component({
    selector: 'app-history-item-mobile',
    templateUrl: './history-item.component.html',
    styleUrls: ['./history-item.component.scss'],
    standalone: false,
})
export class HistoryItemComponentMobile implements OnInit {
    @ViewChild('pdfModal')
    public pdfModal!: ElementRef;

    public historyId: number = 0;
    public doctorid: number = 0;
    public historyType: string = '';
    public resHtml: string = '';
    public historyDatDay: string = '';
    public historyName: string = '';
    public historySpec: string = '';
    public historyTypetext: string = '';
    public historyDepname: string = '';
    public historyDat: Date;
    public pdf: Map<string, ArrayBuffer> = new Map();
    public pdfImageURL = 'assets/icons/documents/pdf-view.svg';
    public isLoading = false;
    public pdfLoading = false;

    public constructor(
        private hs: HistoryService,
        @Inject(MAT_DIALOG_DATA) public dataIN: IHistoryEvents,
        private configS: ConfigService,
        private alert: AlertService,
        private modalService: NgbModal,
        private http: HttpNewService,
        private load: LoadService,
    ) {
        this.historyDat = dataIN.dtSort;
        this.historyDatDay = dataIN.dat;
        this.historyName = dataIN.doctor;
        this.historySpec = dataIN.spec;
        this.historyTypetext = dataIN.typeText;
        this.historyDepname = dataIN.depName;
        this.doctorid = dataIN.doctorId;
        if (dataIN && dataIN.typeHistory && dataIN.keyId) {
            this.historyId = dataIN.keyId;
            this.historyType = dataIN.typeHistory;
        }
    }

    /**
     * В случае если изображение на сервере не найдено то грузим локальное изображение
     * @param event
     */
    public errorHandlerIMG(event: any, type: string): void {
        event.target.src = `${this.configS.getValue(
            'hostBackend',
        )}/img/${type}/not.png`;
    }

    public async gotToDownload(id: number, tp: string, $event: MouseEvent) {
        $event.stopPropagation();
        this.pdfLoading = true;
        let statePdfFull: number = this.load.configData?.CLIENT_SETTINGS
            .PAGES_SETTINGS.HISTORY.HISTORY_VISIT_GET_ADDED_DOCUMENTS_ENABLED
            ? 1
            : 0;
        switch (statePdfFull) {
            case 1:
                try {
                    await lastValueFrom(
                        this.http.get<Map<string, ArrayBuffer>>(
                            `/history/events/item/visitpdf/${tp}/${id}`,
                            null,
                            false,
                        ),
                    )
                        .then((v) => {
                            this.pdf = v;
                            this.modalService.open(this.pdfModal);
                        })
                        .catch((e) => this.alert.warn(e))
                        .finally(() => (this.pdfLoading = false));
                } catch (e) {
                    console.log(e);
                    this.alert.warn('Произошла ошибка');
                }
                break;
            default:
                try {
                    const res = await lastValueFrom(
                        this.http.get<string | IHistoryItemHtmlList>(
                            this.getDownloadUrlForPDF(id, tp),
                            null,
                            true,
                        ),
                    );
                    // 1 кейс, если рез пришел IHistoryItemHtmlList, обрабатываем флаг линк или html
                    if (typeof res !== 'string' && res.linkOrHtmlFlag) {
                        if (res.linkOrHtmlFlag === 'html' && res.text) {
                            const newWindow = window.open(
                                'about:blank',
                                '_blank',
                            );
                            if (newWindow) {
                                newWindow.document.open();
                                newWindow.document.write(res.text);
                                newWindow.document.close();
                            }
                            this.pdfLoading = false;
                            return;
                        }
                        if (res.linkOrHtmlFlag === 'link' && res.text) {
                            window.open(res.text, '_blank');
                            this.pdfLoading = false;
                            return;
                        }
                    }
                    // 2 кейс, когда рез это стринг
                    const base64Data = typeof res === 'string' ? res : res.text;
                    if (base64Data) {
                        const file = new Blob([base64Data], {
                            type: 'application/pdf',
                        });
                        const fileURL = URL.createObjectURL(file);

                        const newWindow = window.open('about:blank', '_blank');
                        if (newWindow) {
                            newWindow.location.href = fileURL;
                        }
                    }
                } catch (error) {
                    console.error(error);
                    this.alert.error('Ошибка загрузки');
                } finally {
                    this.pdfLoading = false;
                }
        }
    }
    public getDownloadUrlForPDF(id: number, tp: string) {
        return `/history/events/item/${tp}/${id}.pdf`;
    }

    public ngOnInit(): void {
        this.isLoading = true;
        this.GetItem(this.historyId).then(() => (this.isLoading = false));
    }

    public getImgSrcDoc(id: number | null | undefined): string {
        return `${this.configS.getValue('hostBackend')}/img/doc/${id}.png`;
    }

    public async GetItem(id: number) {
        try {
            const res = await lastValueFrom(
                this.hs.getHistoryItem({
                    id: this.historyId,
                    typeHistory: this.historyType,
                }),
            );

            this.resHtml = '';

            res.forEach((item) => {
                this.resHtml = this.resHtml + item.text;
            });
        } catch (error) {
            //Что-то странное. Постоянная ошибка not params
        }
    }

    /* День и время*/
    public getTalonDateTime(dt: Date | undefined): string {
        if (dt) {
            return formatUiDateTime(dt);
        } else {
            return '';
        }
    }

    /* День недели*/
    public getNameDay(dt: Date | undefined): string {
        if (dt) {
            return getNameDay(dt);
        } else {
            return '';
        }
    }

    public getFIODoc(fio: string | null): string {
        let result = '';

        if (fio) {
            const fioArray = fio.split(' ');
            const lastname = fioArray[0];
            const firstname = fioArray[1];
            const secondname = fioArray[2];

            if (lastname?.length > 0) {
                result = lastname;
            }
            if (firstname?.length > 0) {
                result += ' ' + firstname[0] + '.';
            }
            if (secondname?.length > 0) {
                result += ' ' + secondname[0] + '.';
            }
        }

        return result;
    }

    public openDicomModal(e: MouseEvent, action: TPacsViewerAction = 'VIEW') {
        e.stopPropagation();
        const modal = this.modalService.open(DicomViewModalComponent);
        modal.componentInstance.historyType = this.historyType;
        modal.componentInstance.historyId = this.historyId;
        modal.componentInstance.action = action;
    }

    public pdfToDownload(event: Event, item: any) {
        event.preventDefault();
        const pdfBuffer: ArrayBuffer = item.value.content.data;
        const arr = new Uint8Array(pdfBuffer);
        const blob = new Blob([arr], { type: 'application/pdf' });
        const fileUrl = URL.createObjectURL(blob);
        window.open(fileUrl, '_blank');
    }

    public mouseEnt(event: any) {
        event.stopPropagation();
        event.target.children[0].src =
            'assets/icons/documents/pdf-view-hover.svg';
    }

    public mouseOut(event: any) {
        event.stopPropagation();
        event.target.children[0].src = 'assets/icons/documents/pdf-view.svg';
    }
}
